import type { MetricExplanation, MetricWarning } from '../contracts';

/**
 * SPEC-008 plan §10 — every formula returns a value-or-null plus
 * warnings/explanation; ordinary missing input is never an exception
 * (METRIC-REQ-012/AC-066). Formulas are one layer below `MetricResult`:
 * they do not know about manual overrides, only about their own inputs.
 */
export interface FormulaResult {
  value: number | null;
  warnings: MetricWarning[];
  explanation: MetricExplanation;
}

export function formulaOk(value: number, explanation: MetricExplanation, warnings: MetricWarning[] = []): FormulaResult {
  return { value, explanation, warnings };
}

export function formulaUnknown(explanation: MetricExplanation, warnings: MetricWarning[]): FormulaResult {
  return { value: null, explanation: { ...explanation, result: null }, warnings };
}
